import { useState } from 'react';
import '../../styles/modal.css';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    guideList?: string[];
    onConfirm: () => void;
    onClose: () => void;
    confirmText?: string;
    closeText?: string;
}

const ConfirmModal = ({
                          isOpen,
                          title,
                          message,
                          guideList,
                          onConfirm,
                          onClose,
                          confirmText = '등록',
                          closeText = '닫기',
                      }: ConfirmModalProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await onConfirm();
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal modal-bg" style={{ display: 'block' }} onClick={onClose}>
            <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="guide-box">
                            <h3 className="point-tit middle">{title}</h3>
                            <p className="guide_txt middle">{message}</p>
                            {guideList && guideList.length > 0 && (
                                <ul className="guidF-list mt10">
                                    {guideList.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="modal-info-p">
                            <strong>입력한 정보로 진행하시겠습니까?</strong>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="modal_btn">
                            <button
                                type="button"
                                className="btn cancel"
                                onClick={onClose}
                                disabled={isLoading}
                            >
                                {closeText}
                            </button>
                            <button
                                type="button"
                                className="btn confirm"
                                onClick={handleConfirm}
                                disabled={isLoading}
                            >
                                {isLoading ? '처리 중...' : confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;